import { Box, Card, Container, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import PageTitleWrapper from 'src/components/PageTitleWrapper';

import { fetchInvoiceById } from '../api/billingInvoicingApi';
import BillingItemSummary from '../components/BillingItemSummary';
import CompanySelection from '../components/CompanySelection';
import InvoiceCreation from '../components/InvoiceCreation';
import InvoiceDetails from '../components/InvoiceDetails';
import OrderSelection from '../components/OrderSelection';
import StepperNavigation from '../components/StepperNavigation';
import {
  BillingInvoicingProvider,
  useBillingInvoicing
} from '../context/BillingInvoicingContext';

const StepContent: React.FC = () => {
  const { currentStep } = useBillingInvoicing();

  if (currentStep === 'company-selection') {
    return <CompanySelection />;
  }
  switch (currentStep) {
    case 'order-selection':
      return <OrderSelection />;
    case 'billing-item-summary':
      return <BillingItemSummary />;
    case 'invoice-creation':
      return <InvoiceCreation />;
    case 'invoice-details':
      return <InvoiceDetails />;
    default:
      return null;
  }
};

const InvoiceIdLoader: React.FC = () => {
  const { setInvoice, setCurrentStep, selectedCompany } = useBillingInvoicing();
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const invoiceId = params.get('invoiceId');
    if (invoiceId && selectedCompany) {
      fetchInvoiceById(selectedCompany.id, invoiceId).then((inv) => {
        setInvoice(inv);
        setCurrentStep('invoice-details');
      });
    }
  }, [location.search, setInvoice, setCurrentStep, selectedCompany]);
  return null;
};

const BillingInvoicingPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <BillingInvoicingProvider>
      <InvoiceIdLoader />
      <PageTitleWrapper>
        <Container disableGutters sx={{ width: '100%' }}>
          <Typography variant="h3" component="h3" gutterBottom>
            {t('billing.title', 'Billing & Invoicing')}
          </Typography>
          <Typography variant="subtitle2" gutterBottom>
            {t(
              'billing.subtitle',
              'Manage billing and invoicing for companies and orders'
            )}
          </Typography>
        </Container>
      </PageTitleWrapper>
      <Container disableGutters sx={{ width: '100%' }}>
        <Card sx={{ p: 2, pl: 0.5, pr: 0.5, mb: 4, width: '100%' }}>
          <Box sx={{ width: '100%' }}>
            <StepperNavigation />
          </Box>
        </Card>
      </Container>
      <Container disableGutters sx={{ width: '100%' }}>
        <Card sx={{ p: 3, mb: 4, width: '100%' }}>
          <StepContent />
        </Card>
      </Container>
    </BillingInvoicingProvider>
  );
};

export default BillingInvoicingPage;
